import './NodesConfiguration.scss';
import ManagementNodes from './ManagementNodes';
import Workers from './Workers';

export default function InstanceConfiguration() {
  return (
    <>
      <ManagementNodes />
      <Workers />
    </>
  );
}
